import { render, staticRenderFns } from "./Licence-user.vue?vue&type=template&id=daf6e506"
import script from "./Licence-user.vue?vue&type=script&lang=js"
export * from "./Licence-user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports